import { Grid } from '@material-ui/core'
import React from 'react'
import { VariableClient } from '../../../store/constants/fonction/variable-client'
import { useForm } from 'react-hook-form'
import { createVariableClient, updateVariableClient } from '../../../store/actions/fonction/variable-client-action'
import { useDispatch, useSelector } from 'react-redux'
import { ValidationButton } from '../../common/validation-button'
import { CancelButton } from '../../common/cancel-button'
import { FormAutocomplete, FormInputText } from '../../../dsn-kernel'
import { ChoixType } from '../ChoixType'

export const CreationVariableClient = ({ classes, toEdit, handleClose }) => {
  const dispatch = useDispatch()
  const variableClients = useSelector(state => state.variableClientModule.variableClients)
  const uniqueTags = new Set()
  variableClients.forEach(item => {
    item.tags.forEach(tag => {
      uniqueTags.add(tag)
    })
  })
  const uniqueTagsList = Array.from(uniqueTags)
  const useFormObj = useForm({
    values: toEdit ? toEdit : new VariableClient(),
  })

  const handleCancel = () => {
    handleClose()
  }
  const handleSaveVariableClient = data => {
    const dataToSave = { ...data }
    if (dataToSave.referenceObj && dataToSave.referenceObj.nom) {
      dataToSave.reference = dataToSave.referenceObj.nom
      delete dataToSave.referenceObj
    }
    if (dataToSave.valeurDefautObj && dataToSave.valeurDefautObj.code) {
      dataToSave.valeurDefaut = dataToSave.valeurDefautObj.code
      delete dataToSave.valeurDefautObj
    }
    if (toEdit) {
      dataToSave.nom = toEdit.nom
      dispatch(updateVariableClient(dataToSave))
    } else {
      dispatch(createVariableClient(dataToSave))
    }
  }
  return (
    <>
      <Grid item xs={12} style={{ marginTop: 15, marginBottom: 15 }}>
        <FormInputText
          label={'Nom'}
          name="nom"
          control={useFormObj.control}
          rules={{ required: true }}
          disabled={!!toEdit}
        />
        <ChoixType classes={classes} useFormObj={useFormObj} withValeurDefaut={true} />
        <FormAutocomplete
          label={'Tags'}
          name="tags"
          control={useFormObj.control}
          multiple
          options={uniqueTagsList}
          freeSolo
        />
        <FormInputText
          label={'Description'}
          name="description"
          control={useFormObj.control}
          rules={{ required: true }}
          multiline
          rows={4}
        />
      </Grid>
      <Grid>
        <ValidationButton
          variant="contained"
          size="medium"
          color="primary"
          onClick={useFormObj.handleSubmit(handleSaveVariableClient)}
          className={classes.margin}
        >
          ENREGISTRER
        </ValidationButton>
      </Grid>
      <Grid>
        <CancelButton
          variant="contained"
          size="medium"
          color="primary"
          onClick={handleCancel}
          className={classes.margin}
        >
          ANNULER
        </CancelButton>
      </Grid>
    </>
  )
}
